export interface BabyAgeParts {
  years: number;
  months: number;
  weeks: number;
  days: number;
}

function isLeapYear(year: number): boolean {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

/**
 * Calculates age as years + months + (weeks/days from remaining days).
 *
 * Product rule:
 * - A month is completed on the same calendar day in the next month.
 * - Remaining days are split into weeks (7 days) and days.
 * - Leap-day legal convention: 29.02 birthdays are treated as completed year on 28.02 in non-leap years.
 */
export function calculateBabyAgeParts(birthDate: Date, now: Date = new Date()): BabyAgeParts {
  let years = now.getFullYear() - birthDate.getFullYear();
  let months = now.getMonth() - birthDate.getMonth();
  let remainingDays = now.getDate() - birthDate.getDate();

  if (remainingDays < 0) {
    months--;
    const prevMonth = new Date(now.getFullYear(), now.getMonth(), 0);
    remainingDays += prevMonth.getDate();
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  // Legal/product convention for leap-day birthdays in non-leap years:
  // age year is considered completed on 28.02 when 29.02 doesn't exist.
  const isLeapDayBirthday = birthDate.getMonth() === 1 && birthDate.getDate() === 29;
  const isNonLeapFeb28 = now.getMonth() === 1 && now.getDate() === 28 && !isLeapYear(now.getFullYear());

  if (isLeapDayBirthday && isNonLeapFeb28) {
    years = now.getFullYear() - birthDate.getFullYear();
    months = 0;
    remainingDays = 0;
  }

  const weeks = Math.floor(remainingDays / 7);
  const days = remainingDays % 7;

  return { years, months, weeks, days };
}
